import { render } from "./MTokenCartDelete.vue?vue&type=template&id=641135c6&scoped=true&ts=true"
import script from "./MTokenCartDelete.vue?vue&type=script&lang=ts"
export * from "./MTokenCartDelete.vue?vue&type=script&lang=ts"

import "./MTokenCartDelete.vue?vue&type=style&index=0&id=641135c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641135c6"]])

export default __exports__